// LorryButton.js
import React from 'react';
import './Move.css'
const LorryButton = () => {
  const handleMoveClick = () => {
    window.open('/Logistics', '_blank'); // Adjust the path as needed
  };

  return (
    <button className="m-button" onClick={handleMoveClick}>
      <span className='spanning'>
        M</span>ove's</button>
  );
};

export default LorryButton;
